//Tipos
import {
  CHANGE_DECLARACAO_PF_VALUE_FORM,
  CHANGE_DECLARACAO_PJ_VALUE_FORM,
  HANDLE_CHANGE_DECLARACAO_SOU_PESSOA_FLAG,
  HANDLE_CHANGE_DECLARACAO_RELACIONAMENTO_FLAG,
  HANDLE_CHANGE_DECLARACAO_SOCIO_FLAG,
  HANDLE_CHANGE_DECLARACAO_FATCA_FLAG,
  HANDLE_CHANGE_DECLARACAO_PERSON_FLAG,
  HANDLE_CHANGE_DECLARACAO_OPERACAO_IMPORTACAO,
  HANDLE_CHANGE_PESSOA_AMERICANA,
  CHANGE_DECLARACAO_NIF,
  HANDLE_CHANGE_DADOS_NIF_COUNTRY,
  HANDLE_CHANGE_DADOS_RENDA_MENSAL,
  HANDLE_CHANGE_DADOS_PATRIMONIO,
  FILL_PROFESSION_LIST,
  SET_LISTA_DECLARACAO_ANUAL,
  HANDLE_CHANGE_DECLARACAO_ANUAL
} from './types';

import { Axios, AxiosCadastro } from "../../service/serviceBasic";

export const changeDeclaracaoPFValueForm = (name, value) => (dispatch, getState) => {

  let { declaracaoEspecificaReducer } = getState()
  let formDeclaracaoPF = declaracaoEspecificaReducer.formDeclaracaoPF;

  formDeclaracaoPF[name] = value;
  
  dispatch({
    type: CHANGE_DECLARACAO_PF_VALUE_FORM,
    payload: formDeclaracaoPF
  })
}

export const changeProfession = (event) => (dispatch, getState) => {

  let { declaracaoEspecificaReducer } = getState()
  let formDeclaracaoPF = declaracaoEspecificaReducer.formDeclaracaoPF;

  formDeclaracaoPF.declaracoesEspecificasObrigatorias_ocupacaoPrincipal = event.value;

  dispatch({
    type: CHANGE_DECLARACAO_PF_VALUE_FORM,
    payload: formDeclaracaoPF
  })
}

export const changeDeclaracaoNIF = (value) => dispatch => { 

  dispatch({
    type: CHANGE_DECLARACAO_NIF,
    payload: value
  })
}

export const handleChangeDadosNIFCountry = (event) => ({
  type: HANDLE_CHANGE_DADOS_NIF_COUNTRY,
  payload: event.value,
});



export const changeDeclaracaoPJValueForm = (name, value) => (dispatch, getState) => {

  let { declaracaoEspecificaReducer } = getState()
  let formDeclaracaoPJ = declaracaoEspecificaReducer.formDeclaracaoPJ;

  formDeclaracaoPJ[name] = value;

  dispatch({
    type: CHANGE_DECLARACAO_PJ_VALUE_FORM,
    payload: formDeclaracaoPJ
  })
}

export const handleChangeDeclaracaoSouPessoaFlag = event => (dispatch, getState) => {

  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_SOU_PESSOA_FLAG,
    payload: event.value
  })
}

export const handleChangeDeclaracaoRelacionamentoFlag = event => (dispatch, getState) => {

  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_RELACIONAMENTO_FLAG,
    payload: event.value
  })
}

export const handleChangeDeclaracaoSocioFlag = event => (dispatch, getState) => {
  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_SOCIO_FLAG,
    payload: event.value
  })
}

export const handleChangeDeclaracaoOperacaoImportacao = event => (dispatch, getState) => {
  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_OPERACAO_IMPORTACAO,
    payload: event.value
  })
}

export const handleChangeDeclaracaoFatcaFlag = event => (dispatch, getState) => {

  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_FATCA_FLAG,
    payload: event.value
  })
}

export const handleChangePessoaAmericana = flag => (dispatch) => {
  var value = flag ? true : null; 
  dispatch({
    type: HANDLE_CHANGE_PESSOA_AMERICANA,
    payload: value
  })
}

export const handleChangeDeclaracaoPersonFlag = event => (dispatch, getState) => {
  let updatedValue = event.value;
  if (updatedValue === "true" || updatedValue === "false") {
    updatedValue = JSON.parse(event.value);
  } else {
    updatedValue = null;
  }
  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_PERSON_FLAG,
    payload: updatedValue
  })
}

export const handleChangeDadosRendaMensal = (event) => ({
  type: HANDLE_CHANGE_DADOS_RENDA_MENSAL,
  payload: event.value,
});

export const handleChangeDadosPatrimonio = (event) => ({
  type: HANDLE_CHANGE_DADOS_PATRIMONIO,
  payload: event.value,
});

export const fillProfessionList = () => (dispatch) => {
  return Axios.post("v1/basico/profissao/list")
    .then((response) => {
      let data = response.data.map((x) => ({name: x.Nome, value: x.Nome}));
      dispatch(setProfessionList(data));
    })
};

export const getListDeclaracaoAnualAction = () => (dispatch) => {
  return AxiosCadastro.post("v1/basico/declaracaoAnual/list")
    .then((response) => {
      let data = response.data.Value.map((x) => ({name: x.Descricao, value: x.IdDeclaracaoAnual}));
      dispatch({
        type: SET_LISTA_DECLARACAO_ANUAL,
        payload: data,
      });
    });
};

export const handleChangeDeclaracaoAnual = (event) => dispatch => {
  dispatch({
    type: HANDLE_CHANGE_DECLARACAO_ANUAL,
    payload: event.value,
  });
};

const setProfessionList = (event) => ({
  type: FILL_PROFESSION_LIST,
  payload: event,
});
